export const PROFESSIONAL_BOOKING_STEP_DELAY_MS = 500;
